"use client";
import Enquire, { EnquireProps } from "@cc/enquire";
import { StaticImageData } from "next/image";
import dynamic from "next/dynamic"; // Dynamic imports

// Dynamic imports
const FormDialogButton = dynamic(() => import("@cc/form-dialog-button"), {
  ssr: false,
});
const EnquireAboutFundraising = dynamic(
  () => import("@c/ourCompanies/fund-and-partners/enquire-about-fundraising"),
  {
    ssr: false,
  },
);
const RestockFridges = dynamic(
  () => import("../volunteeringOpportunities/restock-fridges"),
  {
    ssr: false,
  },
);

export interface FundsAndPartnersProps {
  data: {
    title: string;
    subtitle: string;
    description: string;
    buttonText: string;
    location: string;
    date: string;
    time: string;
    phoneNumber: string;
    company: string;
    image: StaticImageData | string;
    formImage: StaticImageData | string;
  }[];
  navId?: string;
}

const FundsAndPartners = (props: FundsAndPartnersProps) => {
  return <Enquire data={enquireData(props.data)} navId={props.navId} />;
};

export default FundsAndPartners;

const enquireData = (
  data: FundsAndPartnersProps["data"],
): EnquireProps["data"] => [
  data[0] && {
    title: data[0].title,
    description: data[0].subtitle,
    image: data[0].image,
    btn: (
      <FormDialogButton
        title={data[0].title}
        image={data[0].formImage}
        description={data[0].description}
        region={data[0].location}
        date={
          data[0].date && data[0].time
            ? `${data[0].date} | ${data[0].time}`
            : undefined
        }
        number={data[0].phoneNumber}
        ReactiveForm={
          <EnquireAboutFundraising
            company={data[0].company}
            title={data[0].title}
          />
        }
      >
        {data[0].buttonText}
      </FormDialogButton>
    ),
  },
  data[1] && {
    title: data[1].title,
    description: data[1].subtitle,
    image: data[1].image,
    btn: (
      <FormDialogButton
        title={data[1].title}
        image={data[1].formImage}
        description={data[1].description}
        region={data[1].location}
        date={
          data[0].date && data[0].time
            ? `${data[0].date} | ${data[0].time}`
            : undefined
        }
        number={data[1].phoneNumber}
        ReactiveForm={<RestockFridges company={data[1].company} />}
      >
        {data[1].buttonText}
      </FormDialogButton>
    ),
  },
];
